export default function (app) {
  // app.config.errorHandler = (error, instance, info) => {
  //   console.log('errorHandler', error, instance, info)
  // }
}